import request from "@/utils/request";

/**
 * 获取token list
 */
export function getTokenList(params) {
  return request.get(`https://unpkg.com/obsswap-tokenlist/tokenlist/${params['chainID']}/tokenlist.json`, params)
}

export function getAnnouncementListData(params) {
  return request.get('https://unpkg.com/obsswap-tokenlist/noticelist.json', params)
}

